export default "__VITE_ASSET__Cn8Ms5Qp__"